module.exports = "<div ui-view=\"rr-instrumentation-panel\"></div>\r\n<div ui-view=\"notification-panel\"></div>\r\n\r\n<div id=\"header-panel\" class=\"shop-header\">\r\n    <wow-header></wow-header>\r\n</div>\r\n<div class=\"shop-header-placeholder\"></div>\r\n<wow-header-delivery-ribbon></wow-header-delivery-ribbon>\r\n<wow-header-notification  class=\"shop-notification\"></wow-header-notification>\r\n\r\n<div id=\"content-container\" class=\"shop-content\" ui-view=\"content\"></div>\r\n\r\n<wow-footer></wow-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/views/shop.view.html
// module id = 1115
// module chunks = 0